"use client";
import { ReactNode } from "react";
import { usePathname } from "next/navigation";
import HomepageStatsAndSocialProof from ".";
import { FeatureFlagComponentResolverClient } from "@/lib/feature-flags/FeatureFlagResolverClient";
import MonarchResolver from "@/monarch/MonarchResolver";
import { LearnPageRedesignTestResult } from "@/monarch/rules/learnPageRedesign/types";
import { MonarchDataConsumer } from "@/monarch/MonarchDataConsumer";

type ShortCodeStatsAndSocialProofProps = {
  children?: ReactNode;
  html_id?: string;
  location?: string;
  text?: string;
};

const LEARN_PAGE_REGEX = /^\/learn\/[^/]+\/?(?:\?.*)?$/;

export function ShortCodeStatsAndSocialProof({
  children,
  html_id = "",
  location,
  text,
}: ShortCodeStatsAndSocialProofProps) {
  const pathname = usePathname();

  return (
    <FeatureFlagComponentResolverClient
      flagKey="NEXT_PUBLIC_FEATURE_LEARN_PAGE_REDESIGN_TRAFFIC"
      variants={{
        legacy: null,
        test: (
          <MonarchResolver<LearnPageRedesignTestResult>
            experimentKey="useLearnPageRedesign"
            variants={{
              control: <> </>,
              test: (
                <MonarchDataConsumer<LearnPageRedesignTestResult>
                  experimentKey="useLearnPageRedesign"
                  render={(testResult) => {
                    const isLearnPage = LEARN_PAGE_REGEX.test(pathname);
                    if (
                      (!testResult?.data?.testimonials ||
                        !testResult.data.testimonials?.enabled) &&
                      !isLearnPage
                    ) {
                      return null;
                    }
                    return (
                      <HomepageStatsAndSocialProof>
                        {children}
                      </HomepageStatsAndSocialProof>
                    );
                  }}
                />
              ),
            }}
            Loader={null}
            fallbackVariant="control"
          />
        ),
      }}
      fallback="legacy"
    />
  );
}
